var _path, _path2, _circle, _circle2, _path3, _path4, _path5, _path6, _ellipse, _path7, _circle3, _path8, _path9, _path10, _path11, _ellipse2, _ellipse3, _circle4, _path12, _path13, _path14, _path15, _path16, _ellipse4, _ellipse5, _circle5, _circle6, _path17, _circle7, _circle8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceiversEmptyHhmtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.568 36.904c0-2.709 2.184-4.904 4.878-4.904h72.474c2.694 0 4.878 2.195 4.878 4.904 0 2.708-2.184 4.903-4.878 4.903h-15.331c-2.694 0-4.878 2.195-4.878 4.904 0 2.708 2.184 4.903 4.878 4.903h35.54c3.464 0 6.272 2.823 6.272 6.305 0 3.482-2.808 6.304-6.272 6.304H39.722c-3.464 0-6.272-2.822-6.272-6.304s2.808-6.305 6.271-6.305h29.966a4.847 4.847 0 0 1-1.742-.322 4.905 4.905 0 0 0 3.135-4.581 4.905 4.905 0 0 0-3.135-4.582 4.845 4.845 0 0 1 1.742-.322h-13.24c-2.695 0-4.879-2.195-4.879-4.903Zm106.62 21.015c0-3.482 2.808-6.305 6.272-6.305h12.544c3.464 0 6.272 2.823 6.272 6.305 0 3.482-2.808 6.304-6.272 6.304H164.46c-3.464 0-6.272-2.822-6.272-6.304ZM39.721 74.03c-3.463 0-6.271 2.823-6.271 6.305 0 3.482 2.808 6.305 6.271 6.305h85.715c3.464 0 6.272-2.823 6.272-6.305 0-3.482-2.808-6.304-6.272-6.304H39.721ZM6.969 101.701c0-2.902 2.34-5.254 5.226-5.254h42.51c2.886 0 5.226 2.352 5.226 5.254 0 2.901-2.34 5.253-5.227 5.253h-2.09c-2.887 0-5.227 2.353-5.227 5.254 0 2.902 2.34 5.254 5.227 5.254h33.449c-2.887 0-5.227-2.352-5.227-5.254 0-2.901 2.34-5.254 5.227-5.254h78.746c2.886 0 5.226 2.353 5.226 5.254 0 2.902-2.34 5.254-5.226 5.254h-14.286c-2.887 0-5.227 2.352-5.227 5.254 0 2.901 2.34 5.254 5.227 5.254h8.014c2.886 0 5.226 2.352 5.226 5.253 0 2.902-2.34 5.254-5.226 5.254h-32.056c2.887 0 5.227 2.352 5.227 5.254 0 2.902-2.34 5.254-5.227 5.254H85.366c-2.886 0-5.226 2.352-5.226 5.254 0 2.901 2.34 5.253 5.226 5.253h6.272c2.886 0 5.226 2.353 5.226 5.254 0 2.902-2.34 5.254-5.226 5.254H48.432c-2.886 0-5.226-2.352-5.226-5.254 0-2.901 2.34-5.254 5.226-5.254h.697c2.887 0 5.227-2.352 5.227-5.253 0-2.902-2.34-5.254-5.227-5.254H5.227c-2.887 0-5.227-2.352-5.227-5.254 0-2.902 2.34-5.254 5.227-5.254h20.906c-2.887 0-5.227-2.352-5.227-5.254 0-2.901 2.34-5.253 5.227-5.253h1.045c2.886 0 5.226-2.353 5.226-5.254 0-2.902-2.34-5.254-5.226-5.254h-2.44c-2.886 0-5.226-2.352-5.226-5.254 0-2.901 2.34-5.254 5.227-5.254H12.195c-2.886 0-5.226-2.352-5.226-5.253Zm174.564 5.253c-2.886 0-5.226 2.353-5.226 5.254 0 2.902 2.34 5.254 5.226 5.254h13.241c2.886 0 5.226-2.352 5.226-5.254 0-2.901-2.34-5.254-5.226-5.254h-13.241Z",
    fill: "#F6F8FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.345 151.086c-2.309 0-4.181 1.882-4.181 4.203 0 2.321 1.872 4.203 4.181 4.203h9.059c2.31 0 4.182-1.882 4.182-4.203 0-2.321-1.872-4.203-4.182-4.203h-9.059Z",
    fill: "#F6F8FC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.721,
    cy: 86.721,
    fill: "#EEF2F5",
    r: 2.721
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.98,
    cy: 145.925,
    fill: "#EEF2F5",
    r: 2.721
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160.747 84.57a.68.68 0 0 1 .962.962l-2.886 2.886a.681.681 0 0 1-.963-.962l2.887-2.886Zm-5.292 5.291a.68.68 0 1 1 .962.962l-2.886 2.886a.68.68 0 1 1-.962-.962l2.886-2.886Zm6.254 2.886a.681.681 0 0 1-.962.962l-2.887-2.886a.682.682 0 0 1 .963-.962l2.886 2.886Zm-5.292-5.291a.68.68 0 1 1-.962.962l-2.886-2.886a.68.68 0 0 1 .962-.962l2.886 2.886ZM49.2 45.956a1.289 1.289 0 1 1 0 2.578h-7.733a1.289 1.289 0 1 1 0-2.578h7.734Zm-14.177 0a1.289 1.289 0 1 1 0 2.578h-7.734a1.289 1.289 0 1 1 0-2.578h7.733ZM39.534 58.2a1.289 1.289 0 0 1-2.578 0v-7.733a1.289 1.289 0 0 1 2.578 0v7.734Zm0-14.177a1.289 1.289 0 0 1-2.578 0v-7.734a1.289 1.289 0 1 1 2.578 0v7.734Z",
    fill: "#D2D9E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.163 45.621c13.425-10.339 25.82-9.982 37.524-6.883 28.82 7.63 43.37 40.274 31.669 76.762-11.701 36.487-62.996 63.337-102.236 57.829-34.725-4.874-43.371-31.753-41.651-46.47 3.098-26.506 25.876-26.587 41.651-34.767 18.588-9.638 7.57-26.85 33.043-46.47Z",
    fill: "url(#a)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M166.45 145.895c0 9.815-8.125 17.772-18.149 17.772-10.023 0-18.148-7.957-18.148-17.772 0-9.815 8.125-17.771 18.148-17.771 10.024 0 18.149 7.956 18.149 17.771Z",
    fill: "#A3AEC3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.353 168.454c12.261 0 22.201-9.94 22.201-22.201 0-12.261-9.94-22.2-22.201-22.2-12.261 0-22.2 9.939-22.2 22.2s9.939 22.201 22.2 22.201Zm0-33.548c.818 0 1.48.663 1.48 1.48v8.387h8.387a1.48 1.48 0 1 1 0 2.96h-8.387v8.387a1.48 1.48 0 1 1-2.96 0v-8.387h-8.386a1.48 1.48 0 1 1 0-2.96h8.386v-8.387c0-.817.663-1.48 1.48-1.48Z",
    fill: "#EDF0F6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.89,
    cy: 77.204,
    rx: 13.41,
    ry: 13.933,
    transform: "rotate(5.738 91.89 77.204)",
    fill: "#ACB8CE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.716 87.442c1.001-4.014 4.7-6.796 8.785-6.386 4.086.41 7.157 3.873 7.34 8.007-2.418 1.542-5.316 2.31-8.346 2.005-3.029-.304-5.717-1.633-7.78-3.626Zm8.863-7.156c2.866.288 5.431-1.892 5.73-4.87.3-2.977-1.781-5.625-4.647-5.913-2.866-.287-5.431 1.893-5.73 4.87-.3 2.978 1.78 5.625 4.647 5.913Z",
    fill: "#FBFBFB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.866,
    cy: 63.977,
    r: 28.833,
    transform: "rotate(5.392 150.866 63.977)",
    fill: "url(#b)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.561 80.95c3.871-8.217 12.589-13.529 22.154-12.626 9.996.944 17.814 8.383 19.674 17.752-5.702 4.778-13.238 7.36-21.23 6.606-8.565-.808-15.9-5.286-20.598-11.732Z",
    fill: "#EDF0F6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M138.344 43.61a4.643 4.643 0 0 1 5.059-4.185l20.28 1.914a4.644 4.644 0 0 1 4.187 5.059l-.789 8.35c-.769 8.154-8.003 14.14-16.156 13.37-8.153-.77-14.139-8.003-13.369-16.156l.788-8.351Z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M144.894 60.327a2.696 2.696 0 0 1 2.937-2.431l6.263.591a2.696 2.696 0 0 1 2.431 2.938l-.718 7.605a5.84 5.84 0 1 1-11.631-1.098l.718-7.605Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m163.448 43.444 4.098 6.383c1.776-2.54 2.781-7.453 2.271-9.715-.509-2.262-2.693-3.7-3.973-2.899-1.875-2.483-6.689-7.642-10.954-8.414-4.265-.771-6.995 2.885-6.571 4.77-.539-.666-2.046-2.163-7.351-3.402-6.632-1.548-5.893 9.825-2.609 13.294 1.336 1.412 6.164-.573 8.071-1.623.419.347 2.144 1.217 5.693 1.92 3.548.705 9.029.084 11.325-.314Z",
    fill: "#757F9B"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 168.022,
    cy: 54.386,
    rx: 3.595,
    ry: 4.493,
    transform: "rotate(5.392 168.022 54.386)",
    fill: "#fff"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 137.453,
    cy: 51.502,
    rx: 3.595,
    ry: 4.493,
    transform: "rotate(5.392 137.453 51.502)",
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.217,
    cy: 131.018,
    r: 36.651,
    transform: "rotate(-9.696 57.217 131.018)",
    fill: "url(#c)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.23 159.565c2.032-11.367 10.975-20.773 23.013-22.83 12.58-2.149 24.635 4.394 30.019 15.275-5.417 7.752-13.813 13.417-23.871 15.136-10.78 1.842-21.262-1.225-29.16-7.581Z",
    fill: "#EDF0F6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m33.54 134.629 2.629-10.992 38.925-6.651 6.713 9.982c-.422.462-5.071 3.673-9.976 5.448-6.13 2.219-14.106 3.988-22.475 4.832-6.695.675-13.664-1.631-15.816-2.619Z",
    fill: "#757F9B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.856 107.502a6.353 6.353 0 0 1 5.192-7.332l24.085-4.115a6.353 6.353 0 0 1 7.332 5.192l2.222 13.006c1.727 10.109-5.067 19.704-15.177 21.432-10.109 1.727-19.704-5.068-21.432-15.177l-2.222-13.006Z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.42 108.691c3.524-2.585 7.2-7.179 8.633-10.4 2.022 3.126 3.827 5.344 5.653 6.968 2.338 2.079 5.324 5.039 8.778 4.945l-1.81-10.597c-1.573-9.203-13.988-12.124-24.945-9.62-17.175 3.927-14.543 19.341-13.308 26.567 6.344-.589 13.474-5.277 16.999-7.863Z",
    fill: "#757F9B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.33 128.483a3.42 3.42 0 0 1 2.797-3.948l2.89-.494a3.421 3.421 0 0 1 3.948 2.796l2.057 12.042a4.887 4.887 0 1 1-9.634 1.646l-2.057-12.042Z",
    fill: "#fff"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.416,
    cy: 114.965,
    rx: 4.569,
    ry: 5.712,
    transform: "rotate(-9.696 74.416 114.965)",
    fill: "#fff"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.941,
    cy: 121.541,
    rx: 4.569,
    ry: 5.712,
    transform: "rotate(-9.696 35.94 121.541)",
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.64,
    cy: 117.131,
    r: 5.614,
    transform: "rotate(-9.696 62.64 117.131)",
    stroke: "#757F9B",
    strokeWidth: 0.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.875,
    cy: 119.825,
    r: 5.614,
    transform: "rotate(-9.696 46.875 119.825)",
    stroke: "#757F9B",
    strokeWidth: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    stroke: "#757F9B",
    strokeWidth: 0.5,
    d: "m52.704 119.116 4.204-.718"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.733,
    cy: 123.322,
    r: 1.466,
    transform: "rotate(-9.696 75.733 123.322)",
    fill: "#fff"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.198,
    cy: 129.906,
    r: 1.466,
    transform: "rotate(-9.696 37.198 129.906)",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 129.476,
    y1: 27.329,
    x2: 69.402,
    y2: 182.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E7F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5CEDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 150.866,
    y1: 35.144,
    x2: 150.866,
    y2: 92.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3B0C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8795AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 33.369,
    y1: 102.111,
    x2: 81.413,
    y2: 163.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3B0C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8795AF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiversEmptyHhmtIcon);
export default __webpack_public_path__ + "static/media/receivers-empty-hhmt-icon.dcd0c56c43faa675245dbd674f33cebc.svg";
export { ForwardRef as ReactComponent };